declare global {
  interface Window {
    general_settings?: {
      logo_dark?: string;
    };
  }
}

interface HeaderProps {
  logoUrl?: string;
}

const Header = ({ logoUrl }: HeaderProps) => {
  const resolvedLogo = logoUrl || window?.general_settings?.logo_dark;

  return (
    <div className="header">
      <div className="top">
        <div className="advertoriall logo">
          {resolvedLogo && (
            <img src={resolvedLogo} alt="Site Logo" className="center p-2" />
          )}
        </div>
      </div>
      <div className="top_2"></div>
    </div>
  );
};

export default Header;
